import styled from 'styled-components';
import {
    space,
    SpaceProps,
    position,
    PositionProps,
    border,
    BorderProps,
    layout,
    LayoutProps,
    compose,
} from 'styled-system';
import {
    borderPropsArray,
    layoutPropsArray,
    positionPropsArray,
    spacePropsArray,
} from '../utils/styled-components/propArrays';
import { objectFit, ObjectFitProps } from '../utils/styled-components/objectFit';
import { objectPosition, ObjectPositionProps } from '../utils/styled-components/objectPosition';

export type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'width' | 'height' | 'borderRadius'> &
    LayoutProps &
    SpaceProps &
    PositionProps &
    BorderProps &
    ObjectFitProps &
    ObjectPositionProps;

/**
 * Typing this component as React.FC<ImageProps> is a bit of a hack so that the Omit in ImageProps is respected. Otherwise styled components
 * type has all the img properties, including ones we don't want - height/width etc as these clash with styled system props
 */

export const Image: React.FC<ImageProps> = styled.img.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => {
        return (
            ![
                'objectFit',
                'objectPosition',
                ...layoutPropsArray,
                ...positionPropsArray,
                ...spacePropsArray,
                ...borderPropsArray,
            ].includes(prop) && defaultValidatorFn(prop)
        );
    },
})<ImageProps>(compose(layout, position, space, border, objectFit, objectPosition));
